import logging from 'node-logging-js';
import jsb from 'node-jsb';

class StageHeader {
    constructor(element, options) {
        logging.applyLogging(this, 'StageHeader');
        this.logDebug('options:', options);
        this.element = element;

        this.menuBtn = this.element.querySelector('.js-menu-btn');
        this.header = document.querySelector('.js-header');
        this.menuWrap = this.element.querySelector('.js-menu-wrap');

        this.initializeEventListeners();
    }

    initializeEventListeners() {

        this.menuBtn.addEventListener('click', () => {
            if(this.header.classList.contains('is-expanded')){
                setTimeout( () => this.header.setAttribute("style", "z-index: 10"), 400);
                this.header.classList.remove('is-expanded');
            } else {
                this.header.classList.add('is-expanded');
                this.header.setAttribute("style", "z-index: 999");
            }
        });

        window.addEventListener('load', () => {
            this.menuWrap.classList.add('is-loaded');
        });
    }
}

jsb.registerHandler('StageHeader', StageHeader);
export default StageHeader;
